<script setup lang="ts">
import { ChatAgentSidePanel } from '@dashhudson/dashing-ui/chat-agent-side-panel';
import { useSidePanel } from '@dashhudson/dashing-ui/side-panel';
import { onBeforeUnmount } from 'vue';

import VisionAiChatButton from '@/components/VisionAi/chat-panel-components/VisionAiChatButton.vue';
import { VISION_AI_PANEL_TYPE, VISION_PANEL_WIDTH_EXPANDED } from '@/components/VisionAi/constants';

// useSidePanel().close() resets width internally, so setWidth(null) is not needed on close paths.
const { open, close, type, visible, setWidth } = useSidePanel();

function toggleChatWindow() {
  if (visible.value && type.value === VISION_AI_PANEL_TYPE) {
    close();
  } else {
    open(VISION_AI_PANEL_TYPE);
    setWidth(VISION_PANEL_WIDTH_EXPANDED);
  }
}

onBeforeUnmount(() => {
  if (type.value === VISION_AI_PANEL_TYPE) {
    close();
  }
});
</script>

<template>
  <VisionAiChatButton @toggle-chat-window="toggleChatWindow" />
  <ChatAgentSidePanel :type="VISION_AI_PANEL_TYPE" :messages="[]" data-test="VisionChatSidePanel" />
</template>
